/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Event_HistoryInputs */

const en_cargos_event_history = /** @type {(inputs: Cargos_Event_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event History`)
};

const es_cargos_event_history = /** @type {(inputs: Cargos_Event_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de eventos`)
};

/**
* | output |
* | --- |
* | "Event History" |
*
* @param {Cargos_Event_HistoryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_event_history = /** @type {((inputs?: Cargos_Event_HistoryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Event_HistoryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_event_history(inputs)
	return es_cargos_event_history(inputs)
});